import * as React from 'react';
import classnames from 'classnames';

import Tooltip from 'components/Tooltip';
import Spinner from 'components/spinner/Spinner';

import './statistics-side-panel.scss';

type StatisticsSidePanelItem = {
  icon?: React.ReactNode,
  label: string,
  value: string,
  tooltip?: string
};

type Props = {
  items: Array<StatisticsSidePanelItem>,
  children?: React.ReactNode,
  title?: string,
  header?: React.ReactNode,
  footer?: React.ReactNode,
  contextMenu?: React.ReactNode,
  isLoadingStatistics?: boolean
};

const renderSpinner = (): JSX.Element => (
  <div className="statistics-side-panel__spinner">
    <Spinner
      position="inline"
      size="tiny"
      color="light"
    />
  </div>
);

const StatisticsSidePanel = (
  {
    title,
    header,
    footer,
    contextMenu,
    items,
    isLoadingStatistics,
    children
  }: Props
): JSX.Element => {
  const titleClassNames = classnames('statistics-side-panel__title', {
    'statistics-side-panel__title--withHeader': !!header
  });

  return (
    <div className="statistics-side-panel">
      {contextMenu && (
        <div className="statistics-side-panel__context-menu">
          {contextMenu}
        </div>
      )}
      {title && (
        <div className={titleClassNames}>
          {title}
        </div>
      )}
      {header && (
        <div className="statistics-side-panel__header">
          {header}
        </div>
      )}
      {items.map((item) => (
        <div
          key={item.label}
          className="statistics-side-panel__section"
        >
          {item.icon && (
            <div className="statistics-side-panel__section-icon">
              {item.icon}
            </div>
          )}

          <div className="statistics-side-panel__section-label">
            {item.label}
            {item.tooltip && (
              <span className="statistics-side-panel__section-tooltip">
                <Tooltip message={item.tooltip} showQuestionMark />
              </span>
            )}
          </div>

          <div className="statistics-side-panel__section-value">
            {
              isLoadingStatistics
                ? renderSpinner()
                : item.value
            }
          </div>
        </div>
      ))}
      {children}
      {footer && (
        <div className="statistics-side-panel__footer">
          {footer}
        </div>
      )}
    </div>
  );
};

export default StatisticsSidePanel;
